export default {
  noData: '暂无新任务',
  headerTitle: '任务中心',
  limitData: '仅展示14天内的前50个任务',
  jobStatus: {
    pending: '等待处理',
    running: '生成中',
    success: '生成成功',
    failed: '生成失败',
    partSuccess: '部分成功',
    stopped: '终止',
  },
  jobType: {
    vrecRecording: '录屏导出',
    veRender: '视频导出',
    VeSimple: '视频模板',
    aigcTask: 'AI视频生成',
    aiBanner: '链接生图',
    avatarVideo: '数字人视频',
    gmPush: '可玩多组合推送',
    dmDown: '定制可玩下载',
    dmPush: '定制可玩推送',
    aiRemove: 'AI消除',
    subtitles: '字幕识别',
  },
  title: '可玩多组合下载',
}
